(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    // 判断文本是否是数字
function isNumber(text) {
  return text.trim() !== "" && !isNaN(text);
}

// count-up 动画
function animateCount(el, duration = 2000) {
  const target = Number(el.textContent.trim());
  let start = 0;
  const startTime = performance.now();

  function update(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const value = Math.floor(progress * target);
    el.textContent = value;

    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      el.textContent = target; // 最终数字精确
    }
  }

  requestAnimationFrame(update);
}

// IntersectionObserver 配置
const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const container = entry.target;

      // 遍历所有子元素
      container.querySelectorAll('*').forEach(el => {
        if (isNumber(el.textContent)) {
          animateCount(el, 1000);
        }
      });

      // 动画执行后取消监听
      obs.unobserve(container);
    }
  });
}, {
  threshold: 0.1 // 元素 10% 进入视口就触发
});

// 观察所有 .text-is-number 元素
document.querySelectorAll('.text-is-number').forEach(el => {
  observer.observe(el);
});
  } catch(e) { console.error(e); }
})();

})();
